type TShouldForwardPropFn = <O extends object>(prop: keyof O) => boolean;

export const restrictProp = (propsToRestrict: string[]): TShouldForwardPropFn => {
  return (props) => {
    return !propsToRestrict.includes(props as string);
  };
};
